import React from 'react';
import { useTranslation } from 'react-i18next';

const SkipTo = ({ children }) => {
  const { t } = useTranslation();
  return <div id={t('ID CONTENT')}>{children}</div>;
};

export default SkipTo;
